/* import __COLOCATED_TEMPLATE__ from './outbound-campaign-card.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import templateOnlyComponent from '@ember/component/template-only';
import type { Campaign } from './outbound-campaign-list';

interface OutboundCampaignCardSignature {
  Args: {
    campaign: Campaign;
    isArchived?: boolean;
    phoneNumberDisplay: string;
    statusLabel: string;
    statusColor: 'gray' | 'green' | 'sky' | 'red';
    voiceLabel: string | null;
    onClick: () => void;
    onKeydown: (event: KeyboardEvent) => void;
    onEdit: () => void;
  };
}

const OutboundCampaignCard = templateOnlyComponent<OutboundCampaignCardSignature>();
export default OutboundCampaignCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Deploy::Voice::OutboundCampaignCard': typeof OutboundCampaignCard;
    'ai-agent/deploy/voice/outbound-campaign-card': typeof OutboundCampaignCard;
  }
}
